/**
 * Object Restored Event Component
 *
 * Handles ahoy_object_restored events.
 * Display pattern: "**Actor** restored this contact"
 */

import { formatFallback } from '@/lib/crm/utils/labelFormatters';

import { ActorName, InlineText, TimelineEvent } from '../components/shared';
import { useEventFormatters } from '../useEventFormatters';
import type { EventComponentProps } from './types';

export function ObjectRestoredEvent({
  event,
  entityType,
}: EventComponentProps) {
  const { getActorInfo } = useEventFormatters();
  const actor = getActorInfo(event);

  // Format entity type for display (e.g., "ahoy_contact" → "Contact")
  // Strip _entity suffix before formatting to avoid "Contact Entity" → use "Contact"
  const typeWithoutSuffix = entityType.replace(/_entity$/, '');
  const entityTypeLabel = formatFallback(typeWithoutSuffix).toLowerCase();
  const ariaLabel = `${actor.name} restored this ${entityTypeLabel}`;

  return (
    <TimelineEvent ariaLabel={ariaLabel}>
      <TimelineEvent.Icon event={event} />
      <TimelineEvent.Header timestamp={event.occurred_at}>
        <InlineText>
          <ActorName actor={actor} /> restored this {entityTypeLabel}
        </InlineText>
      </TimelineEvent.Header>
    </TimelineEvent>
  );
}
